import React from "react";
import { useNavigate } from "react-router-dom";

const NoPermission = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            display: "flex", flexDirection: "column", justifyContent: "center", 
            alignItems: "center", height: "100vh", textAlign: "center"
        }}>
            <h1 style={{ color: "red", fontSize: "2rem" }}>⛔ Access Denied</h1>
            <p style={{ fontSize: "1.2rem" }}>You don't have permission to view this page.</p>
            <p>Please contact the administrator for access.</p>
            <button 
                onClick={() => navigate(-1)} 
                style={{ padding: "10px 20px", marginTop: "20px", background: "blue", color: "white", border: "none", cursor: "pointer" }}>
                Go Back
            </button>
        </div>
    );
};

export default NoPermission;
